<!-- src/components/NotificationModal.vue -->
<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-content">
     <button class="close-btn" @click="$emit('close')">×</button>
      <div class="modal-header">
        <i class="fa fa-envelope icon"></i>
        <h2>{{ title }}</h2>
      </div>
      <div class="modal-body">
        <p>{{ message }}</p>
      </div>
      <div class="modal-footer">
        <button class="btn-resend" @click="handleResend" v-if="showResend && !resendCountdown">
          RESEND
        </button>
        <div v-if="resendCountdown">Will expire in {{ formattedTime(resendCountdown) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    title: {
      type: String,
      default: 'Verification Email Sent!',
    },
    message: {
      type: String,
      required: true,
    },
    showResend: {
      type: Boolean,
      default: false,
    },
    cooldownStart: Number,
    cooldownDuration: {
      type: Number,
      default: 3600
    }
  },
  data() {
    return {
      resendCountdown: 0,
      countdownInterval: null,
    };
  },
  watch: {
    visible(val) {
      if (val && this.showResend) {
        this.startCountdown();
      }
    },
  },
  methods: {
    formattedTime(seconds) {
      const hrs = Math.floor(seconds / 3600).toString().padStart(2, '0');
      const mins = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
      const secs = (seconds % 60).toString().padStart(2, '0');
      return `${hrs}:${mins}:${secs}`;
    },
    startCountdown() {
      if (!this.cooldownStart) {
        this.resendCountdown = 0;
        return;
      }

      const elapsed = Math.floor((Date.now() - this.cooldownStart) / 1000);
      const remaining = this.cooldownDuration - elapsed;

      this.resendCountdown = remaining > 0 ? remaining : 0;

      clearInterval(this.countdownInterval);

      if (this.resendCountdown > 0) {
        this.countdownInterval = setInterval(() => {
          if (this.resendCountdown > 0) {
            this.resendCountdown--;
          } else {
            clearInterval(this.countdownInterval);
          }
        }, 1000);
      }
    },
    handleResend() {
      this.$emit('resend');
      this.startCountdown();
    },
  },
  beforeDestroy() {
    clearInterval(this.countdownInterval);
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  text-align: center;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}

.modal-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.modal-header .icon {
  font-size: 3rem;
  color: #003A90;
}

.modal-header h2 {
  margin: 0;
  font-weight: bold;
}

.modal-body {
  font-weight: bold;
  color: #F15A22;
}

.modal-footer {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.btn-resend {
  background-color: #003A90;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 6px;
  cursor: pointer;
}

.close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
  padding: 0;
  line-height: 1;
  transition: color 0.2s;
}

.close-btn:hover {
  color: #f46426;
}
</style>
